<template>
    <div v-show="isActive">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: "TabItem",

        props: {
            itemKey: {required: true},
            name: {required: true},
            selected: {default: false},
            defaultSelected: {default: false}
        },

        data() {
            return {
                isActive: false
            };
        },

        computed: {
            href() {
                return '#' + this.itemKey.toLowerCase().replace(/ /g, '-');
            }
        },

        mounted() {
            this.isActive = this.selected;
        }
    }
</script>

<style scoped>

</style>